import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
// Swiper CSS comes from application.bootstrap.scss (swiper-bundle.min); importing
// it here makes esbuild emit its own application.css, clobbering the sass bundle.

export default class extends Controller {
  connect() {
    this.initializeSwiper()
  }

  initializeSwiper() {
    this.swiper = new Swiper(this.element.querySelector('.swiper'), {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      // spaceBetween stays 0: adjacent slides share a single 1px divider
      // (border-right in _site.scss); a gap would double the line
      spaceBetween: 0,
      // Scope to this.element — Recently Viewed and You May Also Like both
      // use this controller and can share a page; bare string selectors
      // would cross-wire their arrows and dots
      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: this.element.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        320: { slidesPerView: 2 },
        576: { slidesPerView: 3 },
        768: { slidesPerView: 4 },
        992: { slidesPerView: 5 },
        1200: { slidesPerView: 6 }
      }
    })
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }
}
